/* eslint-disable */
import { ReactReportContext } from "@sa/rep-react";
import * as React from "react";
import { SingleValueParameter, MultiValueParameter } from "@sa/rep-core";

export function useParameter<R>(parameterId: string | undefined): [R | undefined | null, (value: R | null) => void] {
  const context = React.useContext(ReactReportContext);
  const dataFlow = context?.reportContext.dataFlowService;
  const parameter = React.useMemo(
    () =>
      parameterId ? (dataFlow.getParameter(parameterId) as SingleValueParameter | MultiValueParameter) : undefined,
    [dataFlow, parameterId],
  );
  const [parameterValue, setParameterValue] = React.useState<R | undefined | null>(undefined);

  React.useEffect(() => {
    if (dataFlow) {
      dataFlow.subscribe((params) => {
        if (parameterId && params.has(parameterId)) {
          setParameterValue(params.get(parameterId) as R);
        }
      });
    }
  }, []);

  React.useEffect(() => {
    if (parameter && parameterValue !== parameter.value) {
      setParameterValue(parameter.value as R);
    }
  }, [parameter, parameter?.value]);

  const setter = React.useCallback((value: R | null) => {
      if (parameter) {
        parameter.value = value;
      }
    },
    [parameter],
  );
  return [parameterValue || parameter?.value as R | null | undefined, setter];
}
